import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, STORE_SLUG } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

const LABELS = {
  "shop-all": "Shop All", "player-gear": "Player Gear", "parents-family": "Parents & Family",
  "fan-gear": "Fan Gear", "varsity": "Varsity", "jv": "JV", "middle-school": "Middle School",
};
const COLOR_ORDER = ["Black", "White", "Grey"];

// Expand each flexible product into one card per FRONT DESIGN so all options show on the shop page
function buildVariants(products) {
  const out = [];
  products.forEach((p) => {
    const designs = p.front_designs?.length ? p.front_designs : null;
    if (!designs) { out.push({ product: p, to: `/product/${p.id}`, img: p.front_image, title: p.name, subtitle: "Performance Tee", testId: `product-card-${p.id}` }); return; }
    designs.forEach((d) => {
      let img = p.front_image, colorName = "";
      for (const cn of COLOR_ORDER) {
        const c = (p.colors || []).find((x) => x.name === cn && x.fronts?.[d.key]);
        if (c) { img = c.fronts[d.key]; colorName = c.name; break; }
      }
      if (!colorName) {
        const c = (p.colors || []).find((x) => x.fronts?.[d.key]);
        if (c) { img = c.fronts[d.key]; colorName = c.name; }
      }
      out.push({
        product: p, img, title: d.label, subtitle: p.name,
        to: `/product/${p.id}?design=${d.key}${colorName ? `&color=${colorName}` : ""}`,
        testId: `product-card-${p.id}-${d.key}`,
      });
    });
  });
  return out;
}

export default function Shop() {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [store, setStore] = useState(null);

  useEffect(() => { api.get(`/stores/${STORE_SLUG}`).then((r) => setStore(r.data)); }, []);
  useEffect(() => {
    api.get(`/stores/${STORE_SLUG}/products`, { params: { category } }).then((r) => setProducts(r.data));
  }, [category]);

  const priceFrom = store?.pricing?.front_only ?? 25;
  const variants = buildVariants(products);

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <p className="text-xs uppercase tracking-[0.3em] text-[var(--gv-blue-bright)] font-bold mb-2">Gray Collegiate Academy • War Eagles</p>
      <h1 className="font-display text-5xl sm:text-6xl mb-2" data-testid="shop-heading">{LABELS[category] || "Shop"}</h1>
      <p className="text-sm text-gray-400 mb-8">Pick a design, then choose your color, size &amp; back on the next screen.</p>
      {variants.length === 0 ? (
        <p className="text-gray-400">No products in this category yet.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="product-grid">
          {variants.map((v, i) => (
            <ProductCard key={i} product={v.product} priceFrom={v.product.pricing?.front_only ?? priceFrom}
              image={v.img} title={v.title} subtitle={v.subtitle} to={v.to} testId={v.testId} />
          ))}
        </div>
      )}
    </div>
  );
}
